// festivos.js — festivos nacionales España + Comunitat Valenciana (Alicante).
// Copia frontend de netlify/functions/_holidays.js (con nombre de cada
// festivo, que el backend no necesita) — mismo motivo que _recurrencia.js/
// officeUsers.js: no hay puente de código Node↔navegador en este repo.
// Hardcodeado hasta 2026 — hay que ampliar el objeto cada año.

export const FESTIVOS = {
  // 2025 — nacionales
  '2025-01-01': 'Año Nuevo',
  '2025-01-06': 'Reyes Magos',
  '2025-04-18': 'Viernes Santo',
  '2025-05-01': 'Día del Trabajo',
  '2025-08-15': 'Asunción de la Virgen',
  '2025-10-12': 'Fiesta Nacional de España',
  '2025-11-01': 'Todos los Santos',
  '2025-12-06': 'Día de la Constitución',
  '2025-12-08': 'Inmaculada Concepción',
  '2025-12-25': 'Navidad',
  // 2025 — Comunitat Valenciana
  '2025-03-19': 'San José (Falles)',
  '2025-04-17': 'Jueves Santo (CV)',
  '2025-04-21': 'Lunes de Pascua',
  '2025-10-09': 'Día de la Comunitat Valenciana',
  '2025-12-26': 'San Esteban (CV)',
  // 2026 — nacionales
  '2026-01-01': 'Año Nuevo',
  '2026-01-06': 'Reyes Magos',
  '2026-04-03': 'Viernes Santo',
  '2026-05-01': 'Día del Trabajo',
  '2026-08-15': 'Asunción de la Virgen',
  '2026-10-12': 'Fiesta Nacional de España',
  '2026-11-01': 'Todos los Santos',
  '2026-12-07': 'Día de la Constitución (traslado)',
  '2026-12-08': 'Inmaculada Concepción',
  '2026-12-25': 'Navidad',
  // 2026 — Comunitat Valenciana
  '2026-03-19': 'San José (Falles)',
  '2026-04-02': 'Jueves Santo (CV)',
  '2026-04-06': 'Lunes de Pascua',
  '2026-10-09': 'Día de la Comunitat Valenciana',
  '2026-12-26': 'San Esteban (CV)',
};

export function esFestivo(fechaISO) {
  return !!FESTIVOS[fechaISO];
}
